import { HiChevronDoubleRight } from "react-icons/hi"; 
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from '../../hx/useTranslation';
import '../../../styles/main.css';
import CxAccordion from '../../cx/CxAccordion';
import CxFile from '../../cx/CxFile';
import CxCombo from '../../cx/CxCombo';
import CxToolbar from '../../cx/CxToolbar';
import CxDlgAlert from '../../cx/CxDlgAlert';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxFile from '../../fx/FxFile';
import CxSnackbar from '../../cx/CxSnackbar';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import { useSessionStorage } from '../../hx/useSessionStorage';
import { StoreLongTask, clearStore } from "../../gx/GxStore";
import { useNav } from '../../hx/useNav';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'flex-start',
    gap: 'var(--ibs_container_gap)',
    margin: 'var(--ibs_container_margin)',
  },
}));

const MxPsListImportFile = (props) => {
  const [{ trans }] = useTranslation();
  const classes = useStyles(props);
  const [{ navTo }] = useNav();

  const [csvColumns, setCsvColumns] = React.useState([]);
  const [currentFileName, setCurrentFileName] = React.useState('');
  
  const [fileKey, setFileKey] = React.useState(Date.now());
  const [comboKey, setComboKey] = React.useState(Date.now() + 1);

  // Referencias n_ps
  const rf_file = React.useRef(null);
  const rf_txPs = React.useRef(null);
  const rf_txPsCode = React.useRef(null);
  const rf_txReference = React.useRef(null);
  const rf_nuNature = React.useRef(null);
  const rf_txTypePsGroup = React.useRef(null);
  const rf_txTypePsSubgroup = React.useRef(null);
  const rf_nuCost = React.useRef(null);
  const rf_nuPrice = React.useRef(null);
  const rf_nuTaxPercP = React.useRef(null);
  const rf_nuTaxPercS = React.useRef(null);
  
  // NUEVAS Referencias
  const rf_nuFrequency = React.useRef(null);
  const rf_txUnitP = React.useRef(null);
  const rf_txUnitS = React.useRef(null);
  const rf_nuConversionFactor = React.useRef(null);

  // Referencias n_stock
  const rf_nuStock = React.useRef(null);
  const rf_nuStockMin = React.useRef(null);
  const rf_nuStockMax = React.useRef(null);
  
  // Referencias n_supplier
  const rf_txSupplier = React.useRef(null);
  const rf_txEin = React.useRef(null);
  const rf_txContact = React.useRef(null);
  const rf_txAddress = React.useRef(null);
  const rf_txCity = React.useRef(null);
  const rf_txState = React.useRef(null);
  const rf_txPostalCode = React.useRef(null);
  const rf_txCountry = React.useRef(null);
  const rf_txEmail = React.useRef(null);
  const rf_txWeb = React.useRef(null);
  const rf_txPhone1 = React.useRef(null);
  const rf_txPhone2 = React.useRef(null);
  const rf_txMobile = React.useRef(null);
  
  const r_dlg_alert = React.useRef(null);
  const r_snack_error = React.useRef(null);

  const [storeLongTask, setStoreLongTask] = useSessionStorage('StoreLongTask', StoreLongTask);
  
  React.useEffect(() => {
    clearStore('StoreLongTask', storeLongTask);
    formLoad();
    // eslint-disable-next-line
  }, []);

  const formLoad = async () => {}

  const getRefText = (ref) => {
    if (ref && ref.current && typeof ref.current.getText === 'function') {
      return ref.current.getText();
    }
    return '';
  };

  const clearAllCombos = () => {
    const allRefs = [
      rf_txPs, rf_txPsCode, rf_txReference, rf_nuNature, rf_txTypePsGroup, rf_txTypePsSubgroup, 
      rf_nuCost, rf_nuPrice, rf_nuTaxPercP, rf_nuTaxPercS,
      rf_nuFrequency, rf_txUnitP, rf_txUnitS, rf_nuConversionFactor,
      rf_nuStock, rf_nuStockMin, rf_nuStockMax,
      rf_txSupplier, rf_txEin, rf_txContact, rf_txAddress, rf_txCity, 
      rf_txState, rf_txPostalCode, rf_txCountry, rf_txEmail, rf_txWeb, 
      rf_txPhone1, rf_txPhone2, rf_txMobile
    ];
    
    allRefs.forEach(ref => {
      if (ref && ref.current && typeof ref.current.setVal === 'function') {
        ref.current.setVal('');
      }
    });
  };

  const saveMapping = (fileName) => {
    const mapping = {
      txPs: getRefText(rf_txPs),
      txPsCode: getRefText(rf_txPsCode),
      txReference: getRefText(rf_txReference),
      nuNature: getRefText(rf_nuNature),
      txTypePsGroup: getRefText(rf_txTypePsGroup),
      txTypePsSubgroup: getRefText(rf_txTypePsSubgroup),
      nuCost: getRefText(rf_nuCost),
      nuPrice: getRefText(rf_nuPrice),
      nuTaxPercP: getRefText(rf_nuTaxPercP),
      nuTaxPercS: getRefText(rf_nuTaxPercS),
      nuFrequency: getRefText(rf_nuFrequency),
      txUnitP: getRefText(rf_txUnitP),
      txUnitS: getRefText(rf_txUnitS),
      nuConversionFactor: getRefText(rf_nuConversionFactor),
      nuStock: getRefText(rf_nuStock),
      nuStockMin: getRefText(rf_nuStockMin),
      nuStockMax: getRefText(rf_nuStockMax),
      txSupplier: getRefText(rf_txSupplier),
      txEin: getRefText(rf_txEin),
      txContact: getRefText(rf_txContact),
      txAddress: getRefText(rf_txAddress),
      txCity: getRefText(rf_txCity),
      txState: getRefText(rf_txState),
      txPostalCode: getRefText(rf_txPostalCode),
      txCountry: getRefText(rf_txCountry),
      txEmail: getRefText(rf_txEmail),
      txWeb: getRefText(rf_txWeb),
      txPhone1: getRefText(rf_txPhone1),
      txPhone2: getRefText(rf_txPhone2),
      txMobile: getRefText(rf_txMobile)
    };
    localStorage.setItem(`ibs_csv_map_${fileName}`, JSON.stringify(mapping));
  };

  const restoreMapping = (fileName, currentColumns) => {
    const saved = localStorage.getItem(`ibs_csv_map_${fileName}`);
    if (saved && currentColumns.length > 0) {
      try {
        const mapping = JSON.parse(saved);
        
        const restoreField = (ref, savedText) => {
          if (ref && ref.current && typeof ref.current.setVal === 'function' && savedText) {
            const col = currentColumns.find(c => c.type === savedText);
            if (col) {
              ref.current.setVal(col.id);
            }
          }
        };

        restoreField(rf_txPs, mapping.txPs);
        restoreField(rf_txPsCode, mapping.txPsCode);
        restoreField(rf_txReference, mapping.txReference);
        restoreField(rf_nuNature, mapping.nuNature);
        restoreField(rf_txTypePsGroup, mapping.txTypePsGroup);
        restoreField(rf_txTypePsSubgroup, mapping.txTypePsSubgroup);
        restoreField(rf_nuCost, mapping.nuCost);
        restoreField(rf_nuPrice, mapping.nuPrice);
        restoreField(rf_nuTaxPercP, mapping.nuTaxPercP);
        restoreField(rf_nuTaxPercS, mapping.nuTaxPercS);
        
        restoreField(rf_nuFrequency, mapping.nuFrequency);
        restoreField(rf_txUnitP, mapping.txUnitP);
        restoreField(rf_txUnitS, mapping.txUnitS);
        restoreField(rf_nuConversionFactor, mapping.nuConversionFactor);

        restoreField(rf_nuStock, mapping.nuStock);
        restoreField(rf_nuStockMin, mapping.nuStockMin);
        restoreField(rf_nuStockMax, mapping.nuStockMax);
        
        restoreField(rf_txSupplier, mapping.txSupplier);
        restoreField(rf_txEin, mapping.txEin);
        restoreField(rf_txContact, mapping.txContact);
        restoreField(rf_txAddress, mapping.txAddress);
        restoreField(rf_txCity, mapping.txCity);
        restoreField(rf_txState, mapping.txState);
        restoreField(rf_txPostalCode, mapping.txPostalCode);
        restoreField(rf_txCountry, mapping.txCountry);
        restoreField(rf_txEmail, mapping.txEmail);
        restoreField(rf_txWeb, mapping.txWeb);
        restoreField(rf_txPhone1, mapping.txPhone1);
        restoreField(rf_txPhone2, mapping.txPhone2);
        restoreField(rf_txMobile, mapping.txMobile);
      } catch (error) {
        console.error('Error al restaurar mapeo guardado', error);
      }
    }
  };

  React.useEffect(() => {
    if (csvColumns.length > 0 && currentFileName !== '') {
      setTimeout(() => {
        restoreMapping(currentFileName, csvColumns);
      }, 200);
    }
    // eslint-disable-next-line
  }, [csvColumns, currentFileName]);

  const loadFileColumns = () => {
    clearAllCombos();
    setCsvColumns([]);
    setCurrentFileName('');
    setComboKey(Date.now());
    
    if (!rf_file.current) return;
    const file = rf_file.current.getFile();
    
    if (!file) {
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target.result;
      const firstLine = content.split('\n')[0];
      
      if (firstLine) {
        const commas = (firstLine.match(/,/g) || []).length;
        const semiColons = (firstLine.match(/;/g) || []).length;
        const pipes = (firstLine.match(/\|/g) || []).length;

        let delimiter = ',';
        if (semiColons > commas) delimiter = ';';
        if (pipes > semiColons && pipes > commas) delimiter = '|';
        
        const headers = firstLine.split(delimiter).map(h => 
          h.trim().replace(/^["']|["']$/g, '')
        );
        
        const list = headers.map((header, index) => ({
          id: index.toString(),
          type: header || `Column ${index}`
        }));

        setCsvColumns(list);
        setCurrentFileName(file.name);
      }
    };

    const blob = file.slice(0, 10000); 
    reader.readAsText(blob);
  };

  const goNext = (op) => {
    if (rf_file.current.isEmpty()) { r_snack_error.current.setValAndOpen(`${trans('field.required')}: ${trans('field.file2')} - CSV`); return; }
    if (rf_txPs.current.isEmpty()) { r_snack_error.current.setValAndOpen(`${trans('field.required')}: ${trans('field.name')}`); return; }
    if (rf_txTypePsGroup.current.isEmpty()) { r_snack_error.current.setValAndOpen(`${trans('field.required')}: ${trans('field.group')}`); return; }
    if (rf_txTypePsSubgroup.current.isEmpty()) { r_snack_error.current.setValAndOpen(`${trans('field.required')}: ${trans('field.subgroup')}`); return; }
    if (rf_nuCost.current.isEmpty()) { r_snack_error.current.setValAndOpen(`${trans('field.required')}: ${trans('field.cost')}`); return; }
    if (rf_nuPrice.current.isEmpty()) { r_snack_error.current.setValAndOpen(`${trans('field.required')}: ${trans('field.price')}`); return; }
    if (rf_nuTaxPercP.current.isEmpty()) { r_snack_error.current.setValAndOpen(`${trans('field.required')}: ${trans('field.tax_perc')}-${trans('field.purchases')}`); return; }
    if (rf_nuTaxPercS.current.isEmpty()) { r_snack_error.current.setValAndOpen(`${trans('field.required')}: ${trans('field.tax_perc')}-${trans('field.sales')}`); return; }

    let file = rf_file.current.getFile();
    
    saveMapping(file.name);

    Promise.all([FxFile.getBase64FromFile(file)]).then((result) => {
      let strBase64 = result[0].replace('data:application/pdf;base64,', '');
      
      FxLog.infox('MxPsListImportFile.goNext', '...rf_txPs.current.getVal():', rf_txPs.current.getVal());

      storeLongTask._url = 'pss/import';
      storeLongTask._canCancel = false;
      storeLongTask._record = { 
        txTaskName: "import_pss", 
        strBase64: strBase64,
        txPs: rf_txPs.current.getText(), 
        txPsCode: rf_txPsCode.current.getText(), 
        txReference: rf_txReference.current.getText(), 
        nuNature: rf_nuNature.current.getText(), 
        txTypePsGroup: rf_txTypePsGroup.current.getText(), 
        txTypePsSubgroup: rf_txTypePsSubgroup.current.getText(),
        nuCost: rf_nuCost.current.getText(),
        nuPrice: rf_nuPrice.current.getText(),
        nuTaxPercP: rf_nuTaxPercP.current.getText(),
        nuTaxPercS: rf_nuTaxPercS.current.getText(),
        
        nuFrequency: rf_nuFrequency.current.getText(),
        txUnitP: rf_txUnitP.current.getText(),
        txUnitS: rf_txUnitS.current.getText(),
        nuConversionFactor: rf_nuConversionFactor.current.getText(),

        nuStock: rf_nuStock.current.getText(),
        nuStockMin: rf_nuStockMin.current.getText(),
        nuStockMax: rf_nuStockMax.current.getText(),
        
        txSupplier: rf_txSupplier.current.getText(),
        txEin: rf_txEin.current.getText(),
        txContact: rf_txContact.current.getText(),
        txAddress: rf_txAddress.current.getText(),
        txCity: rf_txCity.current.getText(),
        txState: rf_txState.current.getText(),
        txPostalCode: rf_txPostalCode.current.getText(),
        txCountry: rf_txCountry.current.getText(),
        txEmail: rf_txEmail.current.getText(),
        txWeb: rf_txWeb.current.getText(),
        txPhone1: rf_txPhone1.current.getText(),
        txPhone2: rf_txPhone2.current.getText(),
        txMobile: rf_txMobile.current.getText(),
      };      
      Promise.all([setStoreLongTask(storeLongTask)]).then((result) => {
        navTo('ps-list-import-file-tsk');
      });
    });
  }

  return (
    <div>
      <CxToolbar
        moduleName={`${trans('field.pss')}: ${trans('field.import')}`}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButtonNew icon={<HiChevronDoubleRight fontSize={23} />} classType="ibs_iconbutton_toolbar" onClick={goNext} tooltip={trans('field.next')} />
          </div>
        }
      />

      <div className={classes.container}>

        <CxFile 
          key={fileKey}
          xref={rf_file} 
          label={`${trans('field.file2')} - CSV`} 
          accept='.csv, text/csv, application/vnd.ms-excel'
          onChange={() => {
            FxLog.infox('MxPsListImportFile.rf_file', '...:', 'file changed!');
            loadFileColumns();
          }}
          onClear={() => {
            FxLog.infox('MxPsListImportFile.rf_file', '...:', 'file cleared!');
            setFileKey(Date.now());
            setComboKey(Date.now() + 1);
            setCsvColumns([]);
            setCurrentFileName('');
          }}
          required
        />

        <CxAccordion defaultExpanded title={`${trans('field.fields')} - ${trans('field.equivalence')}`}>
          <React.Fragment key={comboKey}>
            <CxCombo xref={rf_txPs} label={`${trans('field.name')}`} list={csvColumns} required />
            <CxCombo xref={rf_txPsCode} label={`${trans('field.code')}`} list={csvColumns} />
            <CxCombo xref={rf_txReference} label={`${trans('field.reference')}`} list={csvColumns} />
            <CxCombo xref={rf_nuNature} label={`${trans('field.nature')}`} list={csvColumns} />
            <CxCombo xref={rf_txTypePsGroup} label={`${trans('field.group')}`} list={csvColumns} required />
            <CxCombo xref={rf_txTypePsSubgroup} label={`${trans('field.subgroup')}`} list={csvColumns} required />
            <CxCombo xref={rf_nuCost} label={`${trans('field.cost')}`} list={csvColumns} required />
            <CxCombo xref={rf_nuPrice} label={`${trans('field.price')}`} list={csvColumns} required />
            <CxCombo xref={rf_nuTaxPercP} label={`${trans('field.tax_perc')}-${trans('field.purchases')}`} list={csvColumns} required />
            <CxCombo xref={rf_nuTaxPercS} label={`${trans('field.tax_perc')}-${trans('field.sales')}`} list={csvColumns} required />

            <CxCombo xref={rf_nuFrequency} label={trans('field.frequency') || 'Frequency'} list={csvColumns} />
            <CxCombo xref={rf_txUnitP} label={`${trans('field.units')}-${trans('field.purchases')}`} list={csvColumns} />
            <CxCombo xref={rf_txUnitS} label={`${trans('field.units')}-${trans('field.sales')}`} list={csvColumns} />
            <CxCombo xref={rf_nuConversionFactor} label={trans('field.conversion_factor') || 'Conversion Factor'} list={csvColumns} />

            <CxCombo xref={rf_nuStockMin} label={trans('field.stock_min')} list={csvColumns} />
            <CxCombo xref={rf_nuStockMax} label={trans('field.stock_max')} list={csvColumns} />
            <CxCombo xref={rf_nuStock} label={trans('field.stock')} list={csvColumns} />
            
            <CxCombo xref={rf_txSupplier} label={`${trans('field.supplier')}-${trans('field.name')}`} list={csvColumns} />
            <CxCombo xref={rf_txEin} label={`${trans('field.supplier')}-${trans('field.ein')}`} list={csvColumns} />
            <CxCombo xref={rf_txContact} label={`${trans('field.supplier')}-${trans('field.contact')}`} list={csvColumns} />
            <CxCombo xref={rf_txAddress} label={`${trans('field.supplier')}-${trans('field.address')}`} list={csvColumns} />
            <CxCombo xref={rf_txCity} label={`${trans('field.supplier')}-${trans('field.city')}`} list={csvColumns} />
            <CxCombo xref={rf_txState} label={`${trans('field.supplier')}-${trans('field.state')}`} list={csvColumns} />
            <CxCombo xref={rf_txPostalCode} label={`${trans('field.supplier')}-${trans('field.postal_code')}`} list={csvColumns} />
            <CxCombo xref={rf_txCountry} label={`${trans('field.supplier')}-${trans('field.country')}`} list={csvColumns} />
            <CxCombo xref={rf_txEmail} label={`${trans('field.supplier')}-${trans('field.email')}`} list={csvColumns} />
            <CxCombo xref={rf_txWeb} label={`${trans('field.supplier')}-${trans('field.web')}`} list={csvColumns} />
            <CxCombo xref={rf_txPhone1} label={`${trans('field.supplier')}-${trans('field.phone1')}`} list={csvColumns} />
            <CxCombo xref={rf_txPhone2} label={`${trans('field.supplier')}-${trans('field.phone2')}`} list={csvColumns} />
            <CxCombo xref={rf_txMobile} label={`${trans('field.supplier')}-${trans('field.mobile')}`} list={csvColumns} />
          </React.Fragment>
        </CxAccordion>

      </div>

      <CxDlgAlert xref={r_dlg_alert} />

      <CxSnackbar xref={r_snack_error} severity="error" />

    </div>
  );
}

export default MxPsListImportFile;